<mat-tab-group (selectedTabChange)="onTabClick($event)">
  <mat-tab
    label="Gunning Machine 1"
    aria-label="921ec270-541c-46e5-a98d-1dfcd0561ddf"
  >
    <ng-template matTabContent>
      <!-- TAB 1 Gunning Machine 1-->
      <div style="margin: 20px">
        <mat-card>
          <mat-card-content>
            <mat-card style="width: 30%; float: left; margin: 15px">
              <mat-card-title style="padding: 10px 0 0px 20px"
                >Indicadores de Producción de Acero</mat-card-title
              >
              <mat-card-subtitle style="padding: 0px 0 0px 20px"
                >Gunning Machine 1</mat-card-subtitle
              >
              <mat-card-content>
                <div style="float: left">
                  <mat-form-field style="padding-left: 20px">
                    <input
                      matInput
                      type="text"
                      (keyup)="doFilter(2, $event)"
                      placeholder="Filter"
                    />
                  </mat-form-field>
                </div>
                <div style="float: right">
                  <button
                    mat-raised-button
                    (click)="
                      doOpenDialog(2, -1, -1, gunningDispUuid, null, null)
                    "
                    color="primary"
                    style="margin: 0px 20px 10px 0px"
                  >
                    Añadir
                  </button>
                </div>
                <div style="clear: both"></div>
                <table
                  #steelProductionTable
                  mat-table
                  [dataSource]="dataSourceGunningMachineSteelProductionTable"
                  class="mat-elevation-z8"
                >
                  <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="fecha">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Fecha
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      {{ doTransformDate(element.fecha * 1000) }}
                    </td>
                  </ng-container>

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="consumo">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Producción
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      {{ element.consumo }} Tn
                    </td>
                  </ng-container>

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="coladas">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Coladas
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      {{ element.coladas }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acciones">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Acciones
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      <button
                        mat-raised-button
                        (click)="
                          doOpenDialog(
                            2,
                            element._id,
                            0,
                            element.disp,
                            -1 - 1,
                            null
                          )
                        "
                        color="accent"
                        style="margin: 5px 2px"
                      >
                        Editar
                      </button>
                      <button
                        mat-raised-button
                        (click)="
                          doOpenDialog(2, element._id, 1, element.disp, -1, -1)
                        "
                        color="warn"
                        style="margin: 5px 2px"
                      >
                        Eliminar
                      </button>
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="
                      displayedColumnsGunningMachineSteelProductionTable
                    "
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="
                      let row;
                      columns: displayedColumnsGunningMachineSteelProductionTable
                    "
                  ></tr>
                </table>
                <mat-paginator
                  #steelProductionPaginator
                  [pageSizeOptions]="[5, 10, 20]"
                  showFirstLastButtons
                ></mat-paginator>
              </mat-card-content>
            </mat-card>
            <mat-card style="width: 30%; float: left; margin: 15px">
              <mat-card-title style="padding: 10px 0 0px 20px"
                >Consumos de Frimag</mat-card-title
              >
              <mat-card-subtitle style="padding: 0px 0 0px 20px"
                >Gunning Machine 1</mat-card-subtitle
              >
              <mat-card-content>
                <div style="float: left">
                  <mat-form-field style="padding-left: 20px">
                    <input
                      matInput
                      type="text"
                      (keyup)="doFilter(3, $event)"
                      placeholder="Filter"
                    />
                  </mat-form-field>
                </div>
                <div style="float: right">
                  <button
                    mat-raised-button
                    (click)="
                      doOpenDialog(3, -1, -1, gunningDispUuid, null, null)
                    "
                    color="primary"
                    style="margin: 0px 20px 10px 0px"
                  >
                    Añadir
                  </button>
                </div>
                <div style="clear: both"></div>
                <table
                  #frimagConsumptionTable
                  mat-table
                  [dataSource]="dataSourceGunningMachineFrimagConsumptionTable"
                  class="mat-elevation-z8"
                >
                  <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="fecha">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Fecha
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      {{ doTransformDate(element.fecha * 1000) }}
                    </td>
                  </ng-container>

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="consumo">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Consumo
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      {{ element.consumo }} Kgs
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acciones">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Acciones
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      <button
                        mat-raised-button
                        (click)="
                          doOpenDialog(
                            3,
                            element._id,
                            0,
                            element.disp,
                            -1 - 1,
                            null
                          )
                        "
                        color="accent"
                        style="margin: 5px 2px"
                      >
                        Editar
                      </button>
                      <button
                        mat-raised-button
                        (click)="
                          doOpenDialog(3, element._id, 1, element.disp, -1, -1)
                        "
                        color="warn"
                        style="margin: 5px 2px"
                      >
                        Eliminar
                      </button>
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="
                      displayedColumnsGunningMachineFrimagConsumptionTable
                    "
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="
                      let row;
                      columns: displayedColumnsGunningMachineFrimagConsumptionTable
                    "
                  ></tr>
                </table>
                <mat-paginator
                  #frimagConsumptionPaginator
                  [pageSizeOptions]="[5, 10, 20]"
                  showFirstLastButtons
                ></mat-paginator>
              </mat-card-content>
            </mat-card>
            <mat-card style="width: 30%; float: left; margin: 15px">
              <mat-card-title style="padding: 10px 0 0px 20px"
                >Consumos de Magsol</mat-card-title
              >
              <mat-card-subtitle style="padding: 0px 0 0px 20px"
                >Gunning Machine 1</mat-card-subtitle
              >
              <mat-card-content>
                <div style="float: left">
                  <mat-form-field style="padding-left: 20px">
                    <input
                      matInput
                      type="text"
                      (keyup)="doFilter(4, $event)"
                      placeholder="Filter"
                    />
                  </mat-form-field>
                </div>
                <div style="float: right">
                  <button
                    mat-raised-button
                    (click)="
                      doOpenDialog(4, -1, -1, gunningDispUuid, null, null)
                    "
                    color="primary"
                    style="margin: 0px 20px 10px 0px"
                  >
                    Añadir
                  </button>
                </div>
                <div style="clear: both"></div>
                <table
                  #magsolConsumptionTable
                  mat-table
                  [dataSource]="dataSourceGunningMachineMagsolConsumptionTable"
                  class="mat-elevation-z8"
                >
                  <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="fecha">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Fecha
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      {{ doTransformDate(element.fecha * 1000) }}
                    </td>
                  </ng-container>

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="consumo">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Consumo
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      {{ element.consumo }} Kgs
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acciones">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="text-align: center"
                    >
                      Acciones
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      style="text-align: center"
                    >
                      <button
                        mat-raised-button
                        (click)="
                          doOpenDialog(
                            4,
                            element._id,
                            0,
                            element.disp,
                            -1 - 1,
                            null
                          )
                        "
                        color="accent"
                        style="margin: 5px 2px"
                      >
                        Editar
                      </button>
                      <button
                        mat-raised-button
                        (click)="
                          doOpenDialog(4, element._id, 1, element.disp, -1, -1)
                        "
                        color="warn"
                        style="margin: 5px 2px"
                      >
                        Eliminar
                      </button>
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="
                      displayedColumnsGunningMachineMagsolConsumptionTable
                    "
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="
                      let row;
                      columns: displayedColumnsGunningMachineMagsolConsumptionTable
                    "
                  ></tr>
                </table>
                <mat-paginator
                  #magsolConsumptionPaginator
                  [pageSizeOptions]="[5, 10, 20]"
                  showFirstLastButtons
                ></mat-paginator>
              </mat-card-content>
            </mat-card>
            <div style="padding: 0 15px 15px 15px; clear: both">
              <mat-card>
                <mat-card-title style="padding: 10px 0 0px 20px"
                  >Consumos de Impactor</mat-card-title
                >
                <mat-card-subtitle style="padding: 0px 0 0px 20px"
                  >Gunning Machine 1</mat-card-subtitle
                >
                <mat-card-content>
                  <div style="float: left; width: 45%">
                    <div style="float: left">
                      <mat-form-field style="padding-left: 20px">
                        <input
                          matInput
                          type="text"
                          (keyup)="doFilter(5, $event)"
                          placeholder="Filter"
                        />
                      </mat-form-field>
                    </div>
                    <!--
                    <div style="float: right;">
                      <button mat-raised-button (click)="doOpenDialog(4, -1, -1, gunningDispUuid)" color="primary" style="margin: 0px 20px 10px 0px;">Añadir</button>
                    </div>
                    -->
                    <div style="clear: both"></div>
                    <table
                      #impactorConsumptionTable
                      mat-table
                      [dataSource]="
                        dataSourceGunningMachineImpactorConsumptionTable
                      "
                      class="mat-elevation-z8"
                    >
                      <!--- Note that these columns can be defined in any order.
                            The actual rendered columns are set as a property on the row definition" -->

                      <!-- Symbol Column -->
                      <ng-container matColumnDef="fecha">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          style="text-align: center"
                        >
                          Fecha
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element"
                          style="text-align: center"
                        >
                          {{ doTransformDate(element.fecha) }}
                        </td>
                      </ng-container>

                      <!-- Symbol Column -->
                      <ng-container matColumnDef="consumo">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          style="text-align: center"
                        >
                          Consumo
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element"
                          style="text-align: center"
                        >
                          {{ element.consumo }} Kgs
                        </td>
                      </ng-container>
                      <!--
                      <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Acciones </th>
                        <td mat-cell *matCellDef="let element" style="text-align: center;">
                          <button mat-raised-button (click)="doOpenDialog(4, element._id, 0, element.disp, -1. -1)" color="accent" style="margin: 5px 2px;">Editar</button>
                          <button mat-raised-button (click)="doOpenDialog(4, element._id, 1, element.disp, -1, -1)" color="warn" style="margin: 5px 2px;">Eliminar</button>
                        </td>
                      </ng-container>
                      -->
                      <tr
                        mat-header-row
                        *matHeaderRowDef="
                          displayedColumnsGunningMachineImpactorConsumptionTable
                        "
                      ></tr>
                      <tr
                        mat-row
                        *matRowDef="
                          let row;
                          columns: displayedColumnsGunningMachineImpactorConsumptionTable
                        "
                      ></tr>
                    </table>
                    <mat-paginator
                      #impactorConsumptionPaginator
                      [pageSizeOptions]="[5, 10, 20]"
                      showFirstLastButtons
                    ></mat-paginator>
                  </div>
                  <div style="float: right; width: 50%; margin-right: 10px">
                    <!-- Consumption Bar Chart -->
                    <plotly-plot
                      [data]="impactor_consumption_data.data"
                      [layout]="impactor_consumption_data.layout"
                      [useResizeHandler]="true"
                    >
                    </plotly-plot>
                  </div>
                  <div style="clear: both"></div>
                </mat-card-content>
              </mat-card>
            </div>
            <div style="padding: 0 15px 15px 15px; clear: both">
              <mat-card>
                <mat-card-title style="padding: 10px 0 0px 20px"
                  >Listado de Campañas</mat-card-title
                >
                <mat-card-subtitle style="padding: 0px 0 0px 20px"
                  >Gunning Machine 1</mat-card-subtitle
                >
                <mat-card-content>
                  <div style="float: left">
                    <mat-form-field style="padding-left: 20px">
                      <input
                        matInput
                        type="text"
                        (keyup)="doFilter(0, $event)"
                        placeholder="Filter"
                      />
                    </mat-form-field>
                  </div>
                  <div style="float: right">
                    <button
                      mat-raised-button
                      (click)="
                        doOpenDialog(0, -1, -1, gunningDispUuid, null, null)
                      "
                      color="primary"
                      style="margin: 0px 20px 10px 0px"
                    >
                      Añadir
                    </button>
                  </div>
                  <div style="clear: both"></div>
                  <table
                    #campaignsTable
                    mat-table
                    [dataSource]="dataSourceGunningMachineCampaignsTable"
                    class="mat-elevation-z8"
                  >
                    <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                    <!-- Position Column -->
                    <ng-container matColumnDef="uuid">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        UUID
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ element._id }}
                      </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="campaña">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Campaña
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ element.nombre }}
                      </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="ngunnings">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Gunitados
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ element.operations }}
                      </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="inicio">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Inicio
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ doTransformDate(element.inicio * 1000) }}
                      </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="fin">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Finalización
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ doTransformDate(element.fin * 1000) }}
                      </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="duracion">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Duración
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ element.duracion }}
                      </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="estado">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Estado
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        <button
                          mat-raised-button
                          [color]="
                            element.estado == 'EN CURSO' ? 'accent' : 'warn'
                          "
                        >
                          {{ element.estado }}
                        </button>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="visualizar">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Visualizar
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        <button
                          *ngIf="element.estado != 'NO INICIADO'"
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              -1,
                              element.disp,
                              element.inicio,
                              element.fin
                            )
                          "
                          color="primary"
                          style="margin: 5px 2px"
                        >
                          Operaciones
                        </button>
                        <button
                          *ngIf="element.estado != 'NO INICIADO'"
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              2,
                              element.disp,
                              element.inicio,
                              element.fin
                            )
                          "
                          color="primary"
                          style="margin: 5px 2px"
                        >
                          Alarmas
                        </button>
                        <button
                          *ngIf="element.estado == 'FINALIZADO'"
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              3,
                              element.disp,
                              element.inicio,
                              element.fin
                            )
                          "
                          color="primary"
                          style="margin: 5px 2px"
                        >
                          Informe
                        </button>
                        <button
                          *ngIf="element.estado == 'FINALIZADO'"
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              4,
                              element.disp,
                              element.inicio,
                              element.fin
                            )
                          "
                          color="primary"
                          style="margin: 5px 2px"
                        >
                          KPIs
                        </button>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="acciones">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Acciones
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        <button
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              0,
                              element.disp,
                              -1 - 1,
                              null
                            )
                          "
                          color="accent"
                          style="margin: 5px 2px"
                        >
                          Editar
                        </button>
                        <button
                          *ngIf="element.estado == 'NO INICIADO'"
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              1,
                              element.disp,
                              -1,
                              -1
                            )
                          "
                          color="warn"
                          style="margin: 5px 2px"
                        >
                          Eliminar
                        </button>
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="
                        displayedColumnsGunningMachineCampaignsTable
                      "
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="
                        let row;
                        columns: displayedColumnsGunningMachineCampaignsTable
                      "
                      (click)="doHighlight(row)"
                      [style.background]="
                        highlightedRows.indexOf(row) != -1 ? 'lightblue' : ''
                      "
                    ></tr>
                  </table>
                  <mat-paginator
                    #campaignsPaginator
                    [pageSizeOptions]="[5, 10, 20]"
                    showFirstLastButtons
                  ></mat-paginator>
                  <div style="padding: 0 15px 15px 15px">
                    <mat-card>
                      <mat-card-title style="padding-left: 20px"
                        >Listado de Operaciones</mat-card-title
                      >
                      <mat-card-subtitle style="padding-left: 20px"
                        >Campaign:
                        {{ currentGunningCampaign }}</mat-card-subtitle
                      >
                      <mat-card-content>
                        <div>
                          <mat-form-field style="padding-left: 20px">
                            <input
                              matInput
                              type="text"
                              (keyup)="doFilter(1, $event)"
                              placeholder="Filter"
                            />
                          </mat-form-field>
                        </div>
                        <table
                          #operationsTable
                          mat-table
                          [dataSource]="dataSourceGunningMachineOperationsTable"
                          class="mat-elevation-z8"
                        >
                          <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->

                          <!-- Position Column -->
                          <ng-container matColumnDef="uuid">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              UUID
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ element._id }}
                            </td>
                          </ng-container>

                          <!-- Name Column -->
                          <ng-container matColumnDef="campaña">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Campaña
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ element.campaign }}
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="inicio">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Inicio
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ doTransformDate(element.inicio * 1000) }}
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="fin">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Finalización
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ doTransformDate(element.fin * 1000) }}
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="duracion">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Duración
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ element.fin - element.inicio }}
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="producto">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Producto
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ element.campos.productoGunitadoTotal }} kgs
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="agua">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Agua
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{
                                doRoundNumber(element.campos.peticionAgua.total)
                              }}
                              lts
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="estado">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Estado
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              <button
                                mat-raised-button
                                [color]="element.fin == 0 ? 'accent' : 'warn'"
                              >
                                {{
                                  element.fin == 0 ? "EN CURSO" : "FINALIZADO"
                                }}
                              </button>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="consumos">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Consumos
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              <button
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    2,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Producto
                              </button>
                              <button
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    3,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Agua
                              </button>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="visualizar">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Visualizar
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              <button
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    4,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Alarmas
                              </button>
                              <button
                                *ngIf="element.fin != 0"
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    5,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Informe
                              </button>
                            </td>
                          </ng-container>

                          <tr
                            mat-header-row
                            *matHeaderRowDef="
                              displayedColumnsGunningMachineOperationsTable
                            "
                          ></tr>
                          <tr
                            mat-row
                            *matRowDef="
                              let row;
                              columns: displayedColumnsGunningMachineOperationsTable
                            "
                          ></tr>
                        </table>
                        <mat-paginator
                          #operationsPaginator
                          [pageSizeOptions]="[5, 10, 20]"
                          showFirstLastButtons
                        ></mat-paginator>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
